import Reveal from "@/components/Reveal";
import { ArrowRight, Hourglass } from "lucide-react";

export default function Urgency() {
  return (
    <section className="py-16 sm:py-20 bg-[#FFD3C6]/40" data-testid="urgency-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <Reveal>
          <span className="inline-flex w-14 h-14 rounded-2xl bg-white items-center justify-center shadow-[0_6px_16px_rgba(0,0,0,0.06)]">
            <Hourglass className="w-7 h-7 text-[#FF5A5F]" />
          </span>
          <h2 className="mt-6 text-3xl sm:text-4xl font-bold tracking-tight text-[#222]">
            Your Property Could Be Working Harder for You.
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#5a4a48] max-w-2xl mx-auto">
            Every month a property sits vacant is another missed opportunity to generate rental income.
            Our goal is to help reduce unnecessary vacancies, improve earning potential, and remove the
            stress of managing a short-term rental.
          </p>
          <p className="mt-4 text-base sm:text-lg font-semibold text-[#222]">
            The opportunity is worth exploring — especially when you don't have to manage it yourself.
          </p>
          <a
            href="/#calculator"
            data-testid="urgency-cta-button"
            className="mt-8 inline-flex items-center gap-2 bg-[#222222] hover:bg-black text-white font-bold px-8 py-4 rounded-full transition-all duration-200 hover:-translate-y-0.5"
          >
            Find Out What My Property Could Earn
            <ArrowRight className="w-5 h-5" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
